
export default function BorderCard({children}) {
    return (
        <div style={{border: 1, borderStyle: "solid", margin: 1, padding: 1}}>
            {children}
        </div>
    );
}